import { LocaleClub } from '../en/club'

const club: LocaleClub = {
  clubs: '俱乐部',
  clubPosts: '俱乐部帖子',
  myClubs: '我的俱乐部',
  exploreClubs: '探索俱乐部',
  requested: '申请：',
  invited: '受邀者：',
  joinClub: '加入俱乐部',
  leaveClub: '离开俱乐部',
  requestPending: '请求待定',
  invitation: '邀请',
  invitationDesc: '您受到俱乐部主管的邀请，您想加入这个俱乐部吗？',
  acceptInvitation: '您现在是受邀俱乐部的成员。',
  declineInvitation: '您拒绝成为受邀俱乐部的会员。',
  editClub: '编辑俱乐部',
  fixClubPayments: '解决俱乐部账户付款问题',
  setUpYourClubPayments: '设置您的俱乐部付款以创建比赛',
  about: '关于',
  clubDetails: '俱乐部详情',
  clubContact: '俱乐部联系人',
  clubAbout: '关于俱乐部',
  directors: '董事',
  organizers: '组织者',
  invitePlayers: '邀请会员',
  importPlayersCSV: '通过CSV导入会员',
  removeMember: '移除会员',
  removeMemberDesc: '该成员将被俱乐部删除',
  playerAddedSuccess: '选手添加成功',
  importPlayers: '导入选手',
  importMatchesCSV: '通过CSV导入比赛',
  importMatches: '倒入比赛',
  createNewEvent: '创建新比赛',
  eventDetails: '比赛详情',
  addOrganizers: '添加组织者',
  clubOrganizers: '俱乐部组织者必须有一个个人DUPR帐户才能添加到您的俱乐部。',
  clubPlayers: '俱乐部会员必须有一个个人DUPR帐号才能加入您的俱乐部。',
  addOrganizer: '添加组织者',
  addMember: '添加会员',
  inviteAPLayer: '邀请会员',
  inviteAPLayerDesc: '被邀请的会员必须使用下面的电子邮件创建一个帐户，比赛结果才能生效。',
  clubName: '俱乐部名称',
  removeOrganizerTitle: '删除俱乐部组织者',
  removeOrganizerText: '您确定要删除此帐户作为组织者的身份吗？',
  removeOrganizer: '确认',
  createEventDesc: '由于我们目前正在将您连接至我们的 API 合作伙伴，因此无法进行组队和注册。',
  seedMatchesDesc: '不再提供组队服务，我们在准备把你和我们API方达成合作协议。',
  leaveDUPRWarning: '单击此按钮后，您将离开DUPR主页面，回到注册页面。',
  clubsNearMe: '我附近的俱乐部',
}

export default club
